import React, { useState, useEffect } from 'react'
import { ErrorBoundary } from '@sainsburys-tech/bolt'

import SyteIcon from '../../icons/SyteIcon'

import * as Styled from './SyteButton.styles'
import { pushEventAndTrack } from '../../../../helpers/taggingSerializer'

function initAnalyticsListeners(partNumber) {
  // Check to not push sortResults analytics on first load of modal
  let modalOpen = false
  let syteOrigin = ''

  const sortByValues = {
    low_to_high: 'pricelowtohigh',
    high_to_low: 'pricehightolow',
    most_similars: 'mostsimilar'
  }

  window.SyteEvents = [
    {
      name: 'discoveryButtonImpression',
      callback: () => {
        pushEventAndTrack({
          eventInfo: {
            eventName: 'pdp_syteDiscoveryButtonImpression',
            eventAction: 'PDP Syte - Discovery Button Impression'
          },
          attributes: {
            productID: partNumber,
            syteOrigin: 'image'
          }
        })
      }
    },
    {
      name: 'productClicked',
      callback: event => {
        pushEventAndTrack({
          eventInfo: {
            eventName: 'pdp_syteProductClick',
            eventAction: 'PDP Syte Interaction - Product Click'
          },
          attributes: {
            productID: event.sku,
            syteOrigin
          }
        })
      }
    },
    {
      name: 'discoveryButtonClick',
      callback: event => {
        syteOrigin = event.placement === 'main-image' ? 'image' : 'inpage'
        pushEventAndTrack({
          eventInfo: {
            eventName: 'pdp_syteDiscoveryButtonClick',
            eventAction: 'PDP Syte Interaction - Discovery Button Click'
          },
          attributes: {
            productID: partNumber,
            syteOrigin
          }
        })
      }
    },
    {
      name: 'filterResults',
      callback: () => {
        pushEventAndTrack({
          eventInfo: {
            eventName: 'pdp_syteDiscoveryPriceRange',
            eventAction: 'PDP Syte - Discovery Price Range'
          },
          attributes: {
            syteOrigin
          }
        })
      }
    },
    {
      name: 'sortResults',
      callback: event => {
        if (modalOpen) {
          pushEventAndTrack({
            eventInfo: {
              eventName: 'pdp_syteDiscoverylistOption',
              eventAction: 'PDP Syte - Discovery List Option'
            },
            attributes: {
              syteOrigin,
              listOption: sortByValues[event.sort_by]
            }
          })
        } else {
          modalOpen = true
        }
      }
    },
    {
      name: 'modalClosed',
      callback: () => {
        modalOpen = false
        syteOrigin = ''
      }
    }
  ]
}

const SyteButton = ({ src, partNumber }) => {
  initAnalyticsListeners(partNumber)
  const [showSyteButton, setShowSyteButton] = useState(false)
  const [isSyteAppReady, setIsSyteAppReady] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const syteappOnPage = () => {
      setShowSyteButton(true)
    }
    window.addEventListener('syteapp_on_page', syteappOnPage)
    return () => {
      window.removeEventListener('syteapp_on_page', syteappOnPage)
    }
  }, [])

  useEffect(() => {
    const syteappReady = () => {
      setShowSyteButton(true)
      setIsSyteAppReady(true)
      if (loading) {
        setLoading(false)
        document.getElementsByClassName('syte-discovery')[0].click()
      }
    }
    window.addEventListener('syteapp_is_ready', syteappReady)
    return () => {
      window.removeEventListener('syteapp_is_ready', syteappReady)
    }
  }, [loading])

  const handleClick = () => {
    if (!isSyteAppReady) {
      setLoading(true)
    }
  }

  return (
    <ErrorBoundary>
      {showSyteButton && (
        <Styled.SyteButton
          className='syte-discovery'
          data-image-src={`https:${src}`}
          data-sku={partNumber}
          data-placement='main-image'
          aria-label='Find similar products button'
          label='Find similar products'
          kind='secondary'
          onClick={handleClick}
          isLoading={loading}
        >
          <SyteIcon />
          <span>Shop similar</span>
        </Styled.SyteButton>
      )}
    </ErrorBoundary>
  )
}

export default SyteButton
